import { FC } from 'react';
import cx from 'classnames';

export type SpinnerSize = 'sm' | 'md' | 'lg' | 'xl';

export interface SpinnerProps {
  size?: SpinnerSize;
  /** Colour comes from the text colour: pass `text-white`, `text-primary`… */
  className?: string;
  label?: string;
}

const sizeClasses: Record<SpinnerSize, string> = {
  sm: 'size-4 border-2',
  md: 'size-6 border-2',
  lg: 'size-8 border-2',
  xl: 'size-12 border-4',
};

export const Spinner: FC<SpinnerProps> = ({ size = 'md', className, label = 'Загрузка' }) => (
  <span
    role="status"
    aria-label={label}
    className={cx(
      'inline-block shrink-0 animate-spin rounded-full border-current border-t-transparent',
      sizeClasses[size],
      className,
    )}
  />
);
